// Mevcut i18n.js dosyasının güncellenmesi için
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Türkçe çeviriler
const trTranslations = {
  nav: {
    home: 'Ana Sayfa',
    services: 'Hizmetler',
    technologies: 'Teknolojiler',
    references: 'Referanslar',
    careers: 'Kariyer',
    contact: 'İletişim'
  },
  hero: {
    titleStart: 'Dijital Çözüm',
    titleMiddle: 'Ortağınız',
    titleHighlight: 'AJAN',
    subtitle: 'İzmir\'de yazılım mühendisliği, web ve mobil uygulama geliştirme, yapay zeka çözümleri ile işletmenizi dijital dönüşüme hazırlıyoruz.',
    demoButton: 'Projeni Başlat',
    features: [
      'Web & Mobil Geliştirme',
      'Yapay Zeka Çözümleri', 
      'Yazılım Mühendisliği',
      'Dijital Dönüşüm'
    ]
  },
  services: {
    titleHighlight: 'Dijital',
    title: 'Çözümlerimiz',
    subtitle: 'İzmir\'de yazılım mühendisliği deneyimimizle, işletmeniz için özel tasarlanmış modern dijital çözümler sunuyoruz.',
    ctaButton: 'Ücretsiz Danışmanlık Al',
    web: {
      title: 'Web Geliştirme',
      description: 'Modern web teknolojileri (Next.js, React) ile responsive, hızlı ve SEO uyumlu web siteleri ve web uygulamaları geliştiriyoruz.',
      features: ['Responsive Tasarım', 'SEO Optimizasyonu', 'E-Ticaret Çözümleri', 'Admin Panelleri']
    },
    mobile: {
      title: 'Mobil Uygulama',
      description: 'React Native ile iOS ve Android platformları için native performansta, kullanıcı dostu mobil uygulamalar geliştiriyoruz.',
      features: ['Cross-Platform', 'Native Performance', 'Push Notifications', 'Offline Support']
    },
    ai: {
      title: 'Yapay Zeka Çözümleri',
      description: 'ChatGPT, Claude ve açık kaynak AI modelleri entegrasyonları ile işletmenize özel yapay zeka çözümleri geliştiriyoruz.',
      features: ['Chatbot Geliştirme', 'Doküman Analizi', 'Süreç Otomasyonu', 'Predictive Analytics']
    },
    software: {
      title: 'Yazılım Mühendisliği',
      description: 'Kurumsal yazılım projeleri, API geliştirme, veritabanı tasarımı ve sistem entegrasyonları konusunda uzman hizmet veriyoruz.',
      features: ['API Development', 'Database Design', 'System Integration', 'Code Review']
    },
    automation: {
      title: 'İş Süreci Otomasyonu',
      description: 'Excel otomasyonu, web scraping ve iş akışı otomasyonları ile repetitif işlerinizi otomatikleştiriyoruz.',
      features: ['Excel Automation', 'Web Scraping', 'Workflow Automation', 'Data Processing']
    },
    consulting: {
      title: 'Dijital Dönüşüm Danışmanlığı',
      description: 'Teknoloji stratejisi, dijital dönüşüm roadmap\'i ve yazılım mimarisi konularında danışmanlık hizmeti sunuyoruz.',
      features: ['Technology Strategy', 'Digital Roadmap', 'Architecture Design', 'Tech Audit']
    },
    viewDetails: 'Detayları Gör'
  },
  serviceDetail: {
    backToHome: 'Ana Sayfaya Dön',
    features: 'Özellikler',
    process: 'Çalışma Süreci',
    technologies: 'Kullanılan Teknolojiler',
    cta: {
      title: 'Projenize Başlayalım',
      description: 'Uzman ekibimiz ile projelerinizi hayata geçirin. Ücretsiz danışmanlık için bizimle iletişime geçin.',
      whatsapp: 'WhatsApp ile İletişime Geç'
    },
    web: {
      title: 'Web Geliştirme Hizmetleri',
      description: 'Modern web teknolojileri ile responsive, hızlı ve SEO uyumlu web siteleri ve web uygulamaları geliştiriyoruz. İzmir\'de uzman ekibimizle işletmenize özel çözümler sunuyoruz.',
      detailedFeatures: [
        {
          title: 'Responsive Tasarım',
          description: 'Tüm cihazlarda mükemmel görüntüleme'
        },
        {
          title: 'SEO Optimizasyonu',
          description: 'Google\'da üst sıralarda yer alın'
        },
        {
          title: 'E-Ticaret Çözümleri',
          description: 'Online satış platformları'
        },
        {
          title: 'Admin Panelleri',
          description: 'Kolay yönetim arayüzleri'
        },
        {
          title: 'API Entegrasyonu',
          description: 'Üçüncü parti sistem bağlantıları'
        },
        {
          title: 'Progressive Web App',
          description: 'Mobil uygulama deneyimi'
        }
      ],
      process: [
        {
          title: 'Analiz',
          description: 'Gereksinimlerinizi detaylandırıyoruz'
        },
        {
          title: 'Tasarım',
          description: 'UI/UX tasarımı hazırlıyoruz'
        },
        {
          title: 'Geliştirme',
          description: 'Modern teknolojilerle kodluyoruz'
        },
        {
          title: 'Test & Canlı',
          description: 'Test edip yayınlıyoruz'
        }
      ],
      technologies: ['Next.js', 'React', 'TypeScript', 'Tailwind CSS', 'Node.js', 'MongoDB', 'PostgreSQL', 'Vercel', 'AWS']
    },
    mobile: {
      title: 'Mobil Uygulama Geliştirme',
      description: 'React Native ile iOS ve Android platformları için native performansta, kullanıcı dostu mobil uygulamalar geliştiriyoruz.',
      detailedFeatures: [
        {
          title: 'Cross-Platform',
          description: 'Tek kod ile iOS ve Android'
        },
        {
          title: 'Native Performance',
          description: 'Yerli uygulama performansı'
        },
        {
          title: 'Push Notifications',
          description: 'Anlık bildirimler'
        },
        {
          title: 'Offline Support',
          description: 'İnternetsiz çalışma'
        },
        {
          title: 'Biometric Auth',
          description: 'Parmak izi/Yüz tanıma'
        },
        {
          title: 'Real-time Data',
          description: 'Anlık veri senkronizasyonu'
        }
      ],
      process: [
        {
          title: 'Strateji',
          description: 'Mobil strateji geliştiriyoruz'
        },
        {
          title: 'Prototip',
          description: 'Kullanıcı deneyimi tasarlıyoruz'
        },
        {
          title: 'Development',
          description: 'Cross-platform geliştiriyoruz'
        },
        {
          title: 'Store Publish',
          description: 'App Store\'larda yayınlıyoruz'
        }
      ],
      technologies: ['React Native', 'Expo', 'TypeScript', 'Redux', 'Firebase', 'AsyncStorage', 'React Navigation', 'Flipper']
    },
    ai: {
      title: 'Yapay Zeka Çözümleri',
      description: 'ChatGPT, Claude ve açık kaynak AI modelleri entegrasyonları ile işletmenize özel yapay zeka çözümleri geliştiriyoruz.',
      detailedFeatures: [
        {
          title: 'Chatbot Geliştirme',
          description: 'Akıllı müşteri hizmet botları'
        },
        {
          title: 'Doküman Analizi',
          description: 'Otomatik belge işleme'
        },
        {
          title: 'Süreç Otomasyonu',
          description: 'AI destekli iş akışları'
        },
        {
          title: 'Predictive Analytics',
          description: 'Gelecek tahminleme'
        },
        {
          title: 'Computer Vision',
          description: 'Görüntü analizi çözümleri'
        },
        {
          title: 'NLP Solutions',
          description: 'Doğal dil işleme'
        }
      ],
      process: [
        {
          title: 'Data Analysis',
          description: 'Veri setinizi analiz ediyoruz'
        },
        {
          title: 'Model Selection',
          description: 'En uygun AI modelini seçiyoruz'
        },
        {
          title: 'Training',
          description: 'Modelinizi eğitiyoruz'
        },
        {
          title: 'Integration',
          description: 'Sisteminize entegre ediyoruz'
        }
      ],
      technologies: ['OpenAI API', 'Claude', 'LangChain', 'Python', 'TensorFlow', 'PyTorch', 'Hugging Face', 'Vector DB']
    },
    software: {
      title: 'Yazılım Mühendisliği',
      description: 'Kurumsal yazılım projeleri, API geliştirme, veritabanı tasarımı ve sistem entegrasyonları konusunda uzman hizmet veriyoruz.',
      detailedFeatures: [
        {
          title: 'API Development',
          description: 'RESTful ve GraphQL API\'ler'
        },
        {
          title: 'Database Design',
          description: 'Optimized veritabanı mimarisi'
        },
        {
          title: 'System Integration',
          description: 'Sistem entegrasyonları'
        },
        {
          title: 'Code Review',
          description: 'Kod kalite kontrolü'
        },
        {
          title: 'DevOps',
          description: 'CI/CD ve deployment'
        },
        {
          title: 'Microservices',
          description: 'Mikro servis mimarisi'
        }
      ],
      process: [
        {
          title: 'Architecture',
          description: 'Sistem mimarisi tasarlıyoruz'
        },
        {
          title: 'Backend Dev',
          description: 'Sunucu tarafı geliştiriyoruz'
        },
        {
          title: 'Testing',
          description: 'Kapsamlı test ediyoruz'
        },
        {
          title: 'Deployment',
          description: 'Canlı ortama alıyoruz'
        }
      ],
      technologies: ['Node.js', 'Python', 'Java', 'PostgreSQL', 'MongoDB', 'Redis', 'Docker', 'Kubernetes', 'AWS']
    },
    automation: {
      title: 'İş Süreci Otomasyonu',
      description: 'Excel otomasyonu, web scraping ve iş akışı otomasyonları ile repetitif işlerinizi otomatikleştiriyoruz.',
      detailedFeatures: [
        {
          title: 'Excel Automation',
          description: 'VBA ve Python ile Excel otomasyonu'
        },
        {
          title: 'Web Scraping',
          description: 'Otomatik veri toplama'
        },
        {
          title: 'Workflow Automation',
          description: 'İş akışı otomasyonları'
        },
        {
          title: 'Data Processing',
          description: 'Büyük veri işleme'
        },
        {
          title: 'Report Generation',
          description: 'Otomatik rapor oluşturma'
        },
        {
          title: 'Email Automation',
          description: 'E-posta otomasyonları'
        }
      ],
      process: [
        {
          title: 'Process Map',
          description: 'Mevcut süreçleri haritalıyoruz'
        },
        {
          title: 'Automation Design',
          description: 'Otomasyon çözümü tasarlıyoruz'
        },
        {
          title: 'Development',
          description: 'Otomasyon kodlarını yazıyoruz'
        },
        {
          title: 'Training',
          description: 'Kullanım eğitimi veriyoruz'
        }
      ],
      technologies: ['Python', 'VBA', 'Power Automate', 'Selenium', 'Pandas', 'BeautifulSoup', 'n8n', 'Zapier']
    },
    consulting: {
      title: 'Dijital Dönüşüm Danışmanlığı',
      description: 'Teknoloji stratejisi, dijital dönüşüm roadmap\'i ve yazılım mimarisi konularında danışmanlık hizmeti sunuyoruz.',
      detailedFeatures: [
        {
          title: 'Technology Strategy',
          description: 'Teknoloji stratejisi geliştirme'
        },
        {
          title: 'Digital Roadmap',
          description: 'Dijital dönüşüm yol haritası'
        },
        {
          title: 'Architecture Design',
          description: 'Yazılım mimarisi tasarımı'
        },
        {
          title: 'Tech Audit',
          description: 'Teknoloji altyapısı denetimi'
        },
        {
          title: 'Team Training',
          description: 'Ekip eğitimleri'
        },
        {
          title: 'Best Practices',
          description: 'En iyi pratikler'
        }
      ],
      process: [
        {
          title: 'Assessment',
          description: 'Mevcut durumu analiz ediyoruz'
        },
        {
          title: 'Strategy',
          description: 'Dijital strateji oluşturuyoruz'
        },
        {
          title: 'Roadmap',
          description: 'Uygulama planı hazırlıyoruz'
        },
        {
          title: 'Support',
          description: 'Sürekli destek sağlıyoruz'
        }
      ],
      technologies: ['Digital Strategy', 'Agile', 'DevOps', 'Cloud Computing', 'Data Analytics', 'AI/ML', 'Cybersecurity', 'IoT']
    }
  },
  references: {
    titleHighlight: 'Mutlu',
    title: 'Müşterilerimiz',
    subtitle: 'Müşterilerimizin deneyimleri ve otomasyon çözümlerimiz hakkındaki görüşleri.',
    testimonial1: {
      name: 'Ahmet Yılmaz',
      company: 'XYZ Teknoloji A.Ş.',
      text: 'Excel otomasyonu ile finansal raporlama süremizi %80 azalttık. Artık saatler süren işlemleri dakikalar içinde tamamlıyoruz.'
    },
    testimonial2: {
      name: 'Ayşe Kaya',
      company: 'ABC Lojistik Ltd.',
      text: 'Web otomasyonu sayesinde veri giriş hatalarımızı sıfıra indirdik ve müşteri memnuniyetimizi %40 artırdık.'
    },
    testimonial3: {
      name: 'Mehmet Demir',
      company: 'DEF Holding',
      text: 'Yapay zeka tabanlı müşteri analiz otomasyonu ile satışlarımızı %35 artırmayı başardık. Müthiş bir çözüm!'
    }
  },
  privacy: {
    titleStart: 'En Yüksek Seviyede',
    titleHighlight: 'Gizlilik ve Güvenlik',
    description: 'Ajan olarak, müşterilerimizin verileri ve iş süreçleri için en üst düzey gizlilik ve güvenlik önlemlerini uyguluyoruz. Otomasyon çözümlerimizi tasarlarken veri koruma prensiplerimizi her aşamada gözetiyor, işletmenizin hassas bilgilerini endüstri standardı şifreleme teknikleriyle koruyoruz.',
    feature1: 'Uçtan Uca Şifreleme',
    feature2: 'KVKK Uyumlu',
    feature3: 'Veri İzolasyonu'
  },
  technologies: {
    title: 'Kullandığımız',
    titleHighlight: 'Teknolojiler',
    subtitle: 'İşletmenize özel otomasyon ve yapay zeka çözümleri üretmek için en güncel ve güçlü teknolojileri kullanıyoruz.',
    techs: {
      n8n: {
        name: 'n8n',
        description: 'İş akışı otomasyonu için açık kaynaklı ve düğüm tabanlı esnek platform'
      },
      python: {
        name: 'Python',
        description: 'Veri işleme ve otomasyonlar için kullandığımız güçlü programlama dili'
      },
      llama: {
        name: 'Llama',
        description: 'Meta tarafından geliştirilen açık kaynak büyük dil modeli'
      },
      tensorflow: {
        name: 'TensorFlow',
        description: 'Yapay zeka modellerinin eğitimi ve dağıtımı için kullandığımız kütüphane'
      },
      selenium: {
        name: 'Selenium',
        description: 'Web otomasyon işlemleri için kullandığımız test ve kontrol aracı'
      },
      openai: {
        name: 'OpenAI API',
        description: 'GPT modelleri ile doğal dil işleme çözümleri için kullandığımız platform'
      },
      langchain: {
        name: 'LangChain',
        description: 'LLM\'leri dış kaynaklarla bağlama ve yapılandırma için kullandığımız framework'
      },
      zapier: {
        name: 'Zapier',
        description: 'Web uygulamaları arasında entegrasyon sağlayan otomasyon aracı'
      }
    },
    expertise: {
      title: 'Uzmanlık Alanlarımız',
      description: 'Ajan olarak, otomasyon ve yapay zeka entegrasyonları konusunda uzmanlaşmış ekibimizle işletmenizin dijital dönüşümüne öncülük ediyoruz.',
      skills: {
        automation: {
          name: 'İş Süreci Otomasyonu',
          description: 'Tekrarlayan süreçlerinizi otomatikleştirerek zamandan ve kaynaklardan tasarruf etmenizi sağlıyoruz. Excel, web ve diğer platformlarda profesyonel otomasyon çözümleri sunuyoruz.'
        },
        dataAnalysis: {
          name: 'Veri Analizi & İşleme',
          description: 'Verilerinizi anlamlı bilgilere dönüştürüyor ve karar verme süreçlerinizi iyileştiriyoruz. İleri veri işleme teknikleriyle işletmeniz için değer yaratıyoruz.'
        },
        artificialIntelligence: {
          name: 'Yapay Zeka Entegrasyonu',
          description: 'En son yapay zeka teknolojilerini iş süreçlerinize entegre ederek akıllı ve öngörülü sistemler geliştiriyoruz. LLM ve yapay zeka modellerini ihtiyaçlarınıza göre uyarlıyoruz.'
        }
      }
    }
  },
  caseStudies: {
    titleHighlight: 'Örnek',
    title: 'Vaka Çalışmaları',
    subtitle: 'İşte benzer sektörlerde yapabileceklerimizin teorik örnekleri',
    sectorLabel: 'Sektörler',
    problemLabel: 'Problem',
    solutionLabel: 'Çözüm',
    resultsLabel: 'Teorik Sonuçlar',
    ctaButton: 'Benzer Çözümler İçin İletişime Geçin',
    cases: [
      // 1. Personel Harcama Takibi (Yeni ID: 1)
      {
        id: 1,
        title: 'Personel Harcama Takibi Otomasyonu',
        sector: 'İnsan Kaynakları & Finans',
        problem: 'Şirketler, personel harcamalarında anormallikleri tespit etmek için çok fazla zaman harcıyor ve manuel inceleme nedeniyle sorunlar gözden kaçabiliyordu.',
        solution: 'Yapay zeka tabanlı e-posta analizi ile personel harcamalarını otomatik olarak tarayan, anormallikleri tespit eden ve raporlayan bir otomasyon sistemi geliştirildi.',
        results: [
          'Anormalliklerin tespit oranı %95\'e çıktı',
          'Harcama inceleme süresi %80 azaldı',
          'Gereksiz harcamalarda %30 tasarruf sağlandı'
        ]
      },
      // 2. Lojistik Rota (ID: 2 - aynı kalıyor)
      {
        id: 2,
        title: 'Lojistik Rota Optimizasyonu',
        sector: 'Lojistik',
        problem: 'Lojistik şirketi, günlük teslimat rotalarını manuel olarak planlıyor, bu da zaman alıcı ve verimsizdi.',
        solution: 'Yapay zeka destekli rota optimizasyon sistemi kuruldu. Trafik, mesafe ve teslimat önceliklerini dikkate alan algoritma geliştirildi.',
        results: [
          'Yakıt maliyetleri %30 azaldı',
          'Günlük teslimat kapasitesi %45 arttı',
          'Müşteri memnuniyeti %60 yükseldi'
        ]
      },
      // 3. Müşteri Destek (ID: 3 - aynı kalıyor)
      {
        id: 3,
        title: 'Otomatik Müşteri Destek Sistemi',
        sector: 'Müşteri Hizmetleri',
        problem: 'Finansal hizmetler şirketi, tekrarlayan müşteri sorularına yanıt vermek için çok fazla kaynak harcıyordu.',
        solution: 'LLM tabanlı yapay zeka chatbot entegrasyonu ile müşteri sorularının %85\'i otomatik olarak yanıtlanmaya başlandı.',
        results: [
          'Müşteri destek maliyetleri %60 azaldı',
          'Yanıt süresi ortalama 24 saatten 15 dakikaya düştü',
          'Müşteri memnuniyeti skorları %35 arttı'
        ]
      },
      // 4. Veri Analizi (ID: 4 - aynı kalıyor)
      {
        id: 4,
        title: 'Veri Analizi ve Raporlama',
        sector: 'Finans',
        problem: 'Finans kuruluşu aylık raporlarını hazırlamak için 3 günden fazla zaman harcıyordu ve insan hatası riski yüksekti.',
        solution: 'Otomatik veri toplama, analiz ve raporlama sistemi implementasyonu yapıldı.',
        results: [
          'Raporlama süresi 3 günden 2 saate düştü',
          'Hata oranı %97 azaldı',
          'Finansal karar verme süreci %50 hızlandı'
        ]
      },
      // 5. E-Ticaret Stok Yönetimi (Yeni ID: 5)
      {
        id: 5,
        title: 'E-Ticaret Stok Yönetimi',
        sector: 'E-Ticaret',
        problem: 'Büyük bir e-ticaret firması, stok yönetiminde manuel işlemler nedeniyle zaman kaybediyor ve hata oranı yüksekti.',
        solution: 'Excel ve web verileri entegrasyonu ile stok seviyeleri, sipariş durumları ve tedarik süreçleri otomatize edildi.',
        results: [
          'Stok yönetim süresi %75 azaldı',
          'Hata oranı %95 düştü',
          'Personelin değer katan görevlere odaklanma süresi %40 arttı'
        ]
      },
      // 6. Dijital Pazarlama Otomasyonu (Yeni eklenen)
      {
        id: 6,
        title: 'Dijital Pazarlama Otomasyonu',
        sector: 'Pazarlama',
        problem: 'Bir pazarlama ajansı, çok sayıda müşteri için sosyal medya kampanyalarını manuel olarak yönetiyor, içerik planlaması ve analiz süreçlerinde zorlanıyordu.',
        solution: 'Yapay zeka destekli içerik üretimi, otomatik planlama ve çoklu platform entegrasyonu ile dijital pazarlama süreçleri otomatize edildi.',
        results: [
          'İçerik üretim süresi %65 azaltıldı',
          'Kampanya performansı %48 arttı',
          'Müşteri başına yönetim süresi %70 düştü'
        ]
      }
    ]
  },

  searchBar: {
    placeholder: "AJAN 007'e sorunuzu yazın ve Enter'a basın...",
    ariaLabel: "AJAN 007'e soru sorma kutusu"
  },

  contact: {
    titleHighlight: 'Bize',
  title: 'Ulaşın',
  subtitle: 'Otomasyon çözümlerimiz hakkında bilgi almak için bizimle iletişime geçebilirsiniz.',
  emailButton: 'E-posta Gönder',
  whatsappButton: 'WhatsApp\'tan Danışmanlık Al',
  whatsappMessage: 'Merhaba! Dijital çözümleriniz hakkında danışmanlık almak istiyorum.',
  info: {
    title: 'İletişim Bilgilerimiz',
      phone: {
        title: 'Telefon',
        value: '+90 542 269 60 38'
      },
      email: {
        title: 'Email',
        value: 'info@ajan.solutions'
      },
      address: {
        title: 'Adres',
        value: 'Gülbahçe, Urla, Izmir, Türkiye'
      },
      social: {
        title: 'Sosyal Medya'
      }
    }
  },
  footer: {
    about: 'Ajan, Excel, web ve yapay zeka otomasyonları ile işletmelerin iş süreçlerini hızlandıran ve verimli hale getiren yenilikçi bir teknoloji şirketidir.',
    links: {
      title: 'Hızlı Bağlantılar'
    },
    services: {
      title: 'Hizmetlerimiz'
    },
    contact: {
      title: 'İletişim'
    },
    copyright: 'Tüm hakları saklıdır.'
  },
  chatbot: {
    title: "AJAN 007",
    welcomeMessage: "Ajan Merkezine Hoşgeldin! Yorgun gözüküyorsun biraz soluklan.",
    inputPlaceholder: "Mesajınızı yazın...",
    errorMessage: "Üzgünüm, bir hata oluştu. Lütfen tekrar deneyin.",
    typing: "Yazıyor...",
    send: "Gönder",
    thinking: "Düşünüyor...",
    connecting: "Ajan merkezi bağlanıyor...",
    scanComplete: "Tarama tamamlandı. Nasıl yardımcı olabilirim?"
  },
  careers: {
    titleHighlight: 'Kariyer',
    title: 'Fırsatları',
    subtitle: 'AJAN ailesine katılın ve teknoloji dünyasında fark yaratın. İnovatif projelerle geleceği şekillendiren ekibimizin bir parçası olun.',
    joinTeam: 'Ekibimize Katılın',
    positions: {
      title: 'Açık Pozisyonlar',
      subtitle: 'Yetenekli ve tutkulu kişilerle çalışmak için sabırsızlanıyoruz'
    },
    jobs: [
      {
        id: 1,
        title: 'Part-Time Junior Software Developer',
        department: 'Yazılım Geliştirme',
        location: 'İzmir, Türkiye',
        type: 'Yarı Zamanlı',
        experience: 'Junior (0-2 yıl)',
        description: 'Ajan Solutions olarak, temel geliştirme ekibimize katılacak Yarı Zamanlı Junior Yazılım Geliştiricisi arıyoruz. Deneyimli geliştiricilerle birlikte canlı projeler üzerinde çalışacak, modern geliştirme pratiklerini öğrenecek ve gerçek etki yaratan işler yapacaksınız.',
        aboutCompany: 'Ajan Solutions\'da, "herkese uyan" yazılımların aslında kimseye tam olarak uymadığına inanıyoruz. Misyonumuz, her işletmenin operasyonel ihtiyaçlarına tam olarak uygun, özel dijital çözümler geliştirmektir. Sadece uygulama yapmıyoruz, büyüme ve verimlilik motorları yaratıyoruz.',
        responsibilities: [
          'Devam eden React Native (mobil) ve Next.js (web) projelerine katkıda bulunmak',
          'Yeni bileşenler geliştirmek ve mevcut kod tabanlarını sürdürmek',
          'Hata ayıklama, test etme ve performans optimizasyonunda yardımcı olmak',
          'API entegrasyonları yapmak ve işbirlikçi kod incelemelerine katılmak',
          'Gerektiğinde backend görevlerini desteklemek (özellikle Node.js ve Express)'
        ],
        requirements: [
          'Bilgisayar Mühendisliği veya ilgili alanda 3. veya 4. sınıf öğrencisi ya da yeni mezun',
          'JavaScript ve/veya TypeScript temel bilgisi',
          'React Native veya React.js deneyimi (okul, kişisel veya freelance projeler)',
          'Git ve versiyon kontrol sistemleri bilgisi',
          'Öğrenme konusunda güçlü motivasyon ve takım odaklı çalışma'
        ],
        niceToHave: [
          'Node.js, Express veya backend geliştirme deneyimi',
          'Supabase veya diğer BaaS platformları bilgisi',
          'API entegrasyonu ve veritabanı temelleri anlayışı'
        ],
        benefits: [
          'Canlı müşteri projelerinde çalışan deneyimli geliştiricilerden doğrudan mentorluk',
          'İşletmeler tarafından kullanılan aktif ürünlerle gerçek dünya deneyimi',
          'Akademik taahhütlerinize uyum sağlayan esnek çalışma programı',
          'Destekleyici, işbirlikçi ve büyüme odaklı takım kültürü',
          'Performansa dayalı tam zamanlı role geçiş fırsatı',
          'Rekabetçi yarı zamanlı ücret'
        ]
      }
    ],
    application: {
      title: 'Başvuru Formu',
      subtitle: 'Bizimle çalışmak istiyorsanız, lütfen formu doldurun.',
      form: {
        personalInfo: 'Kişisel Bilgiler',
        fullName: 'Ad Soyad',
        email: 'E-posta',
        phone: 'Telefon',
        position: 'Başvurduğunuz Pozisyon',
        experience: 'Deneyim Yılı',
        cv: 'CV Yükle',
        coverLetter: 'Motivation Mektubu',
        coverLetterPlaceholder: 'Neden AJAN\'da çalışmak istiyorsunuz? Deneyimlerinizi ve hedeflerinizi kısaca açıklayın...',
        submit: 'Başvuru Gönder',
        sending: 'Gönderiliyor...',
        success: 'Başvurunuz başarıyla gönderildi!',
        error: 'Hata oluştu, lütfen tekrar deneyin.'
      },
      validation: {
        required: 'Bu alan zorunludur',
        invalidEmail: 'Geçerli bir e-posta adresi giriniz',
        invalidPhone: 'Geçerli bir telefon numarası giriniz'
      }
    },
    labels: {
      aboutCompany: 'Şirket Hakkında',
      responsibilities: 'Sorumluluklar',
      requirements: 'Gereksinimler',
      niceToHave: 'Artı Değer',
      benefits: 'Avantajlar'
    },
    benefits: {
      title: 'Neden AJAN?',
      items: [
        {
          title: 'İnovatif Projeler',
          description: 'En güncel teknolojilerle çalışma fırsatı'
        },
        {
          title: 'Esnek Çalışma',
          description: 'Hibrit ve remote çalışma seçenekleri'
        },
        {
          title: 'Gelişim İmkanları',
          description: 'Sürekli öğrenme ve gelişim desteği'
        },
        {
          title: 'Rekabetçi Maaş',
          description: 'Sektör standartlarının üzerinde maaş'
        }
      ]
    }
  },
  searchBar: {
    placeholder: "AJAN 007'e bir görev talebi yazın...",
    ariaLabel: "AJAN 007'e görev talebi iletme alanı",
    enterKey: "Gönder",
    searching: "Görev kodu analiz ediliyor...",
    scanComplete: "Analiz tamamlandı",
    commandHint: "Görevinizi yazıp Enter'a basın"
  }
};

// İngilizce çeviriler
const enTranslations = {
  nav: {
    home: 'Home',
    services: 'Services',
    technologies: 'Technologies',
    references: 'References',
    careers: 'Careers',
    contact: 'Contact',
    login: "Login",
    register: "Sign Up"
  },
  hero: {
    titleStart: 'Your Digital',
    titleMiddle: 'Solution',
    titleHighlight: 'Partner',
    subtitle: 'Software engineering, web & mobile app development, AI solutions in Izmir. Preparing your business for digital transformation.',
    demoButton: 'Start Your Project',
    features: [
      'Web & Mobile Development',
      'AI Solutions',
      'Software Engineering', 
      'Digital Transformation'
    ]
  },
  services: {
    titleHighlight: 'Digital',
    title: 'Solutions',
    subtitle: 'With our software engineering experience in Izmir, we offer custom-designed modern digital solutions for your business.',
    ctaButton: 'Get Free Consultation',
    web: {
      title: 'Web Development',
      description: 'We develop responsive, fast and SEO-friendly websites and web applications with modern web technologies (Next.js, React).',
      features: ['Responsive Design', 'SEO Optimization', 'E-Commerce Solutions', 'Admin Panels']
    },
    mobile: {
      title: 'Mobile Application',
      description: 'We develop user-friendly mobile applications with native performance for iOS and Android platforms using React Native.',
      features: ['Cross-Platform', 'Native Performance', 'Push Notifications', 'Offline Support']
    },
    ai: {
      title: 'AI Solutions',
      description: 'We develop custom AI solutions for your business with ChatGPT, Claude and open-source AI model integrations.',
      features: ['Chatbot Development', 'Document Analysis', 'Process Automation', 'Predictive Analytics']
    },
    software: {
      title: 'Software Engineering',
      description: 'We provide expert services in enterprise software projects, API development, database design and system integrations.',
      features: ['API Development', 'Database Design', 'System Integration', 'Code Review']
    },
    automation: {
      title: 'Business Process Automation',
      description: 'We automate your repetitive tasks with Excel automation, web scraping and workflow automations.',
      features: ['Excel Automation', 'Web Scraping', 'Workflow Automation', 'Data Processing']
    },
    consulting: {
      title: 'Digital Transformation Consulting',
      description: 'We provide consulting services on technology strategy, digital transformation roadmap and software architecture.',
      features: ['Technology Strategy', 'Digital Roadmap', 'Architecture Design', 'Tech Audit']
    },
    viewDetails: 'View Details'
  },
  serviceDetail: {
    backToHome: 'Back to Home',
    features: 'Features',
    process: 'Work Process',
    technologies: 'Technologies Used',
    cta: {
      title: 'Let\'s Start Your Project',
      description: 'Bring your projects to life with our expert team. Contact us for free consultation.',
      whatsapp: 'Contact via WhatsApp'
    },
    web: {
      title: 'Web Development Services',
      description: 'We develop responsive, fast and SEO-friendly websites and web applications with modern web technologies. We offer custom solutions for your business with our expert team in Izmir.',
      detailedFeatures: [
        {
          title: 'Responsive Design',
          description: 'Perfect display on all devices'
        },
        {
          title: 'SEO Optimization',
          description: 'Rank high on Google'
        },
        {
          title: 'E-Commerce Solutions',
          description: 'Online sales platforms'
        },
        {
          title: 'Admin Panels',
          description: 'Easy management interfaces'
        },
        {
          title: 'API Integration',
          description: 'Third party system connections'
        },
        {
          title: 'Progressive Web App',
          description: 'Mobile app experience'
        }
      ],
      process: [
        {
          title: 'Analysis',
          description: 'We detail your requirements'
        },
        {
          title: 'Design',
          description: 'We prepare UI/UX design'
        },
        {
          title: 'Development',
          description: 'We code with modern technologies'
        },
        {
          title: 'Test & Live',
          description: 'We test and publish'
        }
      ],
      technologies: ['Next.js', 'React', 'TypeScript', 'Tailwind CSS', 'Node.js', 'MongoDB', 'PostgreSQL', 'Vercel', 'AWS']
    },
    mobile: {
      title: 'Mobile App Development',
      description: 'We develop user-friendly mobile applications with native performance for iOS and Android platforms using React Native.',
      detailedFeatures: [
        {
          title: 'Cross-Platform',
          description: 'iOS and Android with single code'
        },
        {
          title: 'Native Performance',
          description: 'Native app performance'
        },
        {
          title: 'Push Notifications',
          description: 'Instant notifications'
        },
        {
          title: 'Offline Support',
          description: 'Works without internet'
        },
        {
          title: 'Biometric Auth',
          description: 'Fingerprint/Face recognition'
        },
        {
          title: 'Real-time Data',
          description: 'Real-time data synchronization'
        }
      ],
      process: [
        {
          title: 'Strategy',
          description: 'We develop mobile strategy'
        },
        {
          title: 'Prototype',
          description: 'We design user experience'
        },
        {
          title: 'Development',
          description: 'We develop cross-platform'
        },
        {
          title: 'Store Publish',
          description: 'We publish on App Stores'
        }
      ],
      technologies: ['React Native', 'Expo', 'TypeScript', 'Redux', 'Firebase', 'AsyncStorage', 'React Navigation', 'Flipper']
    },
    ai: {
      title: 'AI Solutions',
      description: 'We develop custom AI solutions for your business with ChatGPT, Claude and open-source AI model integrations.',
      detailedFeatures: [
        {
          title: 'Chatbot Development',
          description: 'Smart customer service bots'
        },
        {
          title: 'Document Analysis',
          description: 'Automatic document processing'
        },
        {
          title: 'Process Automation',
          description: 'AI-powered workflows'
        },
        {
          title: 'Predictive Analytics',
          description: 'Future forecasting'
        },
        {
          title: 'Computer Vision',
          description: 'Image analysis solutions'
        },
        {
          title: 'NLP Solutions',
          description: 'Natural language processing'
        }
      ],
      process: [
        {
          title: 'Data Analysis',
          description: 'We analyze your dataset'
        },
        {
          title: 'Model Selection',
          description: 'We select the most suitable AI model'
        },
        {
          title: 'Training',
          description: 'We train your model'
        },
        {
          title: 'Integration',
          description: 'We integrate into your system'
        }
      ],
      technologies: ['OpenAI API', 'Claude', 'LangChain', 'Python', 'TensorFlow', 'PyTorch', 'Hugging Face', 'Vector DB']
    },
    software: {
      title: 'Software Engineering',
      description: 'We provide expert services in enterprise software projects, API development, database design and system integrations.',
      detailedFeatures: [
        {
          title: 'API Development',
          description: 'RESTful and GraphQL APIs'
        },
        {
          title: 'Database Design',
          description: 'Optimized database architecture'
        },
        {
          title: 'System Integration',
          description: 'System integrations'
        },
        {
          title: 'Code Review',
          description: 'Code quality control'
        },
        {
          title: 'DevOps',
          description: 'CI/CD and deployment'
        },
        {
          title: 'Microservices',
          description: 'Microservice architecture'
        }
      ],
      process: [
        {
          title: 'Architecture',
          description: 'We design system architecture'
        },
        {
          title: 'Backend Dev',
          description: 'We develop server-side'
        },
        {
          title: 'Testing',
          description: 'We test comprehensively'
        },
        {
          title: 'Deployment',
          description: 'We deploy to production'
        }
      ],
      technologies: ['Node.js', 'Python', 'Java', 'PostgreSQL', 'MongoDB', 'Redis', 'Docker', 'Kubernetes', 'AWS']
    },
    automation: {
      title: 'Business Process Automation',
      description: 'We automate your repetitive tasks with Excel automation, web scraping and workflow automations.',
      detailedFeatures: [
        {
          title: 'Excel Automation',
          description: 'Excel automation with VBA and Python'
        },
        {
          title: 'Web Scraping',
          description: 'Automatic data collection'
        },
        {
          title: 'Workflow Automation',
          description: 'Business workflow automations'
        },
        {
          title: 'Data Processing',
          description: 'Big data processing'
        },
        {
          title: 'Report Generation',
          description: 'Automatic report generation'
        },
        {
          title: 'Email Automation',
          description: 'Email automations'
        }
      ],
      process: [
        {
          title: 'Process Map',
          description: 'We map existing processes'
        },
        {
          title: 'Automation Design',
          description: 'We design automation solution'
        },
        {
          title: 'Development',
          description: 'We write automation code'
        },
        {
          title: 'Training',
          description: 'We provide usage training'
        }
      ],
      technologies: ['Python', 'VBA', 'Power Automate', 'Selenium', 'Pandas', 'BeautifulSoup', 'n8n', 'Zapier']
    },
    consulting: {
      title: 'Digital Transformation Consulting',
      description: 'We provide consulting services on technology strategy, digital transformation roadmap and software architecture.',
      detailedFeatures: [
        {
          title: 'Technology Strategy',
          description: 'Technology strategy development'
        },
        {
          title: 'Digital Roadmap',
          description: 'Digital transformation roadmap'
        },
        {
          title: 'Architecture Design',
          description: 'Software architecture design'
        },
        {
          title: 'Tech Audit',
          description: 'Technology infrastructure audit'
        },
        {
          title: 'Team Training',
          description: 'Team trainings'
        },
        {
          title: 'Best Practices',
          description: 'Best practices'
        }
      ],
      process: [
        {
          title: 'Assessment',
          description: 'We analyze current situation'
        },
        {
          title: 'Strategy',
          description: 'We create digital strategy'
        },
        {
          title: 'Roadmap',
          description: 'We prepare implementation plan'
        },
        {
          title: 'Support',
          description: 'We provide ongoing support'
        }
      ],
      technologies: ['Digital Strategy', 'Agile', 'DevOps', 'Cloud Computing', 'Data Analytics', 'AI/ML', 'Cybersecurity', 'IoT']
    }
  },
  references: {
    titleHighlight: 'Happy',
    title: 'Clients',
    subtitle: 'Experiences of our clients and their opinions about our automation solutions.',
    testimonial1: {
      name: 'John Smith',
      company: 'XYZ Technology Inc.',
      text: 'With Excel automation, we reduced our financial reporting time by 80%. We now complete processes that used to take hours in just minutes.'
    },
    testimonial2: {
      name: 'Sarah Johnson',
      company: 'ABC Logistics Ltd.',
      text: 'Thanks to web automation, we reduced our data entry errors to zero and increased our customer satisfaction by 40%.'
    },
    testimonial3: {
      name: 'Michael Brown',
      company: 'DEF Holding',
      text: 'We managed to increase our sales by 35% with AI-based customer analysis automation. An amazing solution!'
    }
  },
  privacy: {
    titleStart: 'Highest Level of',
    titleHighlight: 'Privacy and Security',
    description: 'At Ajan, we implement top-tier privacy and security measures for our clients\' data and business processes. We prioritize data protection principles at every stage when designing our automation solutions, protecting your business\'s sensitive information with industry-standard encryption techniques.',
    feature1: 'End-to-End Encryption',
    feature2: 'GDPR Compliant',
    feature3: 'Data Isolation'
  },
  technologies: {
    title: 'Our',
    titleHighlight: 'Technologies',
    subtitle: 'We use the latest and most powerful technologies to create custom automation and AI solutions for your business.',
    techs: {
      n8n: {
        name: 'n8n',
        description: 'Open-source, node-based flexible platform for workflow automation'
      },
      python: {
        name: 'Python',
        description: 'Powerful programming language we use for data processing and automations'
      },
      llama: {
        name: 'Llama',
        description: 'Open-source large language model developed by Meta'
      },
      tensorflow: {
        name: 'TensorFlow',
        description: 'Library we use for training and deploying artificial intelligence models'
      },
      selenium: {
        name: 'Selenium',
        description: 'Testing and control tool we use for web automation operations'
      },
      openai: {
        name: 'OpenAI API',
        description: 'Platform we use for natural language processing solutions with GPT models'
      },
      langchain: {
        name: 'LangChain',
        description: 'Framework we use to connect and structure LLMs with external resources'
      },
      zapier: {
        name: 'Zapier',
        description: 'Automation tool that provides integration between web applications'
      }
    },
    expertise: {
      title: 'Our Areas of Expertise',
      description: 'At Ajan, we lead your business\'s digital transformation with our team specialized in automation and AI integrations.',
      skills: {
        automation: {
          name: 'Business Process Automation',
          description: 'We help you save time and resources by automating repetitive processes. We offer professional automation solutions on Excel, web, and other platforms.'
        },
        dataAnalysis: {
          name: 'Data Analysis & Processing',
          description: 'We transform your data into meaningful insights and improve your decision-making processes. We create value for your business with advanced data processing techniques.'
        },
        artificialIntelligence: {
          name: 'AI Integration',
          description: 'We develop intelligent and predictive systems by integrating the latest artificial intelligence technologies into your business processes. We adapt LLMs and AI models to your specific needs.'
        }
      }
    }
  },
  caseStudies: {
    titleHighlight: 'Case',
    title: 'Studies',
    subtitle: 'Theoretical examples of what we can do in similar sectors',
    sectorLabel: 'Sectors',
    problemLabel: 'Problem',
    solutionLabel: 'Solution',
    resultsLabel: 'Theoretical Results',
    ctaButton: 'Contact Us for Similar Solutions',
    cases: [
      // 1. Employee Expense Tracking (Yeni ID: 1)
      {
        id: 1,
        title: 'Employee Expense Tracking Automation',
        sector: 'HR & Finance',
        problem: 'Companies were spending too much time detecting anomalies in employee expenses, and issues were being missed due to manual review.',
        solution: 'Developed an automation system that uses AI to analyze emails, automatically scans employee expenses, detects anomalies, and generates reports.',
        results: [
          'Anomaly detection rate increased to 95%',
          'Expense review time reduced by 80%',
          'Achieved 30% savings on unnecessary expenses'
        ]
      },
      // 2. Logistics Route Optimization (ID: 2 - aynı kalıyor)
      {
        id: 2,
        title: 'Logistics Route Optimization',
        sector: 'Logistics',
        problem: 'A logistics company was manually planning daily delivery routes, which was time-consuming and inefficient.',
        solution: 'Implemented an AI-powered route optimization system with algorithms considering traffic, distance, and delivery priorities.',
        results: [
          'Fuel costs reduced by 30%',
          'Daily delivery capacity increased by 45%',
          'Customer satisfaction improved by 60%'
        ]
      },
      // 3. Automated Customer Support (ID: 3 - aynı kalıyor)
      {
        id: 3,
        title: 'Automated Customer Support System',
        sector: 'Customer Service',
        problem: 'A financial services company was spending too many resources answering repetitive customer inquiries.',
        solution: 'Integrated an LLM-based AI chatbot that automatically answered 85% of customer questions.',
        results: [
          'Customer support costs reduced by 60%',
          'Response time decreased from 24 hours to 15 minutes on average',
          'Customer satisfaction scores increased by 35%'
        ]
      },
      // 4. Data Analysis and Reporting (ID: 4 - aynı kalıyor)
      {
        id: 4,
        title: 'Data Analysis and Reporting',
        sector: 'Finance',
        problem: 'A financial institution was spending more than 3 days preparing monthly reports with high risk of human error.',
        solution: 'Implemented an automated data collection, analysis, and reporting system.',
        results: [
          'Reporting time reduced from 3 days to 2 hours',
          'Error rate decreased by 97%',
          'Financial decision-making process accelerated by 50%'
        ]
      },
      // 5. E-Commerce Inventory Management (Yeni ID: 5)
      {
        id: 5,
        title: 'E-Commerce Inventory Management',
        sector: 'E-Commerce',
        problem: 'A large e-commerce company was losing time with manual inventory management processes and had a high error rate.',
        solution: 'Stock levels, order statuses, and supply processes were automated with Excel and web data integration.',
        results: [
          'Inventory management time reduced by 75%',
          'Error rate decreased by 95%',
          'Staff time for value-added tasks increased by 40%'
        ]
      },
      // 6. Digital Marketing Automation (Yeni eklenen)
      {
        id: 6,
        title: 'Digital Marketing Automation',
        sector: 'Marketing',
        problem: 'A marketing agency was manually managing social media campaigns for numerous clients, struggling with content planning and analysis processes.',
        solution: 'Digital marketing processes were automated with AI-powered content generation, automatic scheduling, and multi-platform integration.',
        results: [
          'Content production time reduced by 65%',
          'Campaign performance increased by 48%',
          'Management time per client decreased by 70%'
        ]
      }
    ]
  },
  careers: {
    titleHighlight: 'Career',
    title: 'Opportunities',
    subtitle: 'Join the AJAN family and make a difference in the technology world. Be part of our team that shapes the future with innovative projects.',
    joinTeam: 'Join Our Team',
    positions: {
      title: 'Open Positions',
      subtitle: 'We are excited to work with talented and passionate individuals'
    },
    jobs: [
      {
        id: 1,
        title: 'Part-Time Junior Software Developer',
        department: 'Software Development',
        location: 'Izmir, Turkey',
        type: 'Part-time',
        experience: 'Junior (0-2 years)',
        description: 'We are looking for a Part-Time Junior Software Developer to join our core development team. You will collaborate closely with experienced developers on live projects, learn modern development practices, and create real impact.',
        aboutCompany: 'At Ajan Solutions, we believe that "one-size-fits-all" software rarely fits anyone perfectly. Our mission is to build tailor-made digital solutions that align precisely with each business\'s operational needs. We don\'t just build apps, we create engines for growth and efficiency.',
        responsibilities: [
          'Contribute to ongoing React Native (mobile) and Next.js (web) projects',
          'Develop new components and maintain existing codebases',
          'Assist in debugging, testing, and performance optimization',
          'Integrate APIs and participate in collaborative code reviews',
          'Support backend tasks when needed, particularly using Node.js and Express'
        ],
        requirements: [
          '3rd, or 4th-year student, or a recent graduate in Computer Engineering or a related field',
          'Basic knowledge of JavaScript and/or TypeScript',
          'Experience (through school, personal, or freelance projects) with React Native or React.js',
          'Familiarity with Git and version control systems',
          'Strong motivation to learn and take ownership in a team-oriented environment'
        ],
        niceToHave: [
          'Some experience with Node.js, Express, or backend development',
          'Familiarity with Supabase or other BaaS platforms',
          'Understanding of API integration and database fundamentals'
        ],
        benefits: [
          'Direct mentorship from experienced developers working on live client projects',
          'Real-world, hands-on experience with active products used by businesses',
          'A flexible working schedule that adapts to your academic commitments',
          'A supportive, collaborative, and growth-driven team culture',
          'Opportunity to transition into a full-time role based on performance',
          'Competitive part-time compensation'
        ]
      }
    ],
    application: {
      title: 'Application Form',
      subtitle: 'If you want to work with us, please fill out the form.',
      form: {
        personalInfo: 'Personal Information',
        fullName: 'Full Name',
        email: 'Email',
        phone: 'Phone',
        position: 'Position Applied For',
        experience: 'Years of Experience',
        cv: 'Upload CV',
        coverLetter: 'Cover Letter',
        coverLetterPlaceholder: 'Why do you want to work at AJAN? Briefly explain your experience and goals...',
        submit: 'Submit Application',
        sending: 'Sending...',
        success: 'Your application has been sent successfully!',
        error: 'An error occurred, please try again.'
      },
      validation: {
        required: 'This field is required',
        invalidEmail: 'Please enter a valid email address',
        invalidPhone: 'Please enter a valid phone number'
      }
    },
    labels: {
      aboutCompany: 'About Company',
      responsibilities: 'Responsibilities',
      requirements: 'Requirements',
      niceToHave: 'Nice to Have',
      benefits: 'Benefits'
    },
    benefits: {
      title: 'Why AJAN?',
      items: [
        {
          title: 'Innovative Projects',
          description: 'Opportunity to work with the latest technologies'
        },
        {
          title: 'Flexible Work',
          description: 'Hybrid and remote work options'
        },
        {
          title: 'Development Opportunities',
          description: 'Continuous learning and development support'
        },
        {
          title: 'Competitive Salary',
          description: 'Above industry standard salary'
        }
      ]
    }
  },
  
  searchBar: {
    placeholder: "Ask AJAN 007 a question and press Enter...",
    ariaLabel: "Ask AJAN 007 a question"
  },  
  // İngilizce
contact: {
  titleHighlight: 'Contact',
  title: 'Us',
  subtitle: 'You can get in touch with us to learn more about our automation solutions.',
  emailButton: 'Send Email',
  whatsappButton: 'Get WhatsApp Consultation',
  whatsappMessage: 'Hello! I would like to get consultation about your digital solutions.',
  info: {
    title: 'Contact Information',
    phone: {
      title: 'Phone',
      value: '+90 542 269 60 38'
    },
    email: {
      title: 'Email',
      value: 'info@ajan.solutions'
    },
    address: {
      title: 'Address',
      value: 'Gülbahçe, Urla, Izmir, Türkiye'
    },
    social: {
      title: 'Social Media'
    }
  }
},
  footer: {
    about: 'Ajan is an innovative technology company that accelerates and streamlines business processes through Excel, web, and AI automation solutions.',
    links: {
      title: 'Quick Links'
    },
    services: {
      title: 'Our Services'
    },
    contact: {
      title: 'Contact'
    },
    copyright: 'All rights reserved.'
  },
  chatbot: {
    title: "AJAN 007",
    welcomeMessage: "Welcome to Agent Headquarters! You look tired, take a moment to catch your breath.",
    inputPlaceholder: "Type your message...",
    errorMessage: "Sorry, an error occurred. Please try again.",
    typing: "Typing...",
    send: "Send",
    thinking: "Thinking...",
    connecting: "Connecting to agent headquarters...",
    scanComplete: "Scan complete. How may I assist you?"
  },
  searchBar: {
    placeholder: "Enter a mission request for AJAN 007...",
    ariaLabel: "Mission request area for AJAN 007",
    enterKey: "Send",
    searching: "Analyzing mission code...",
    scanComplete: "Analysis complete",
    commandHint: "Type your mission and press Enter"  
  }

};

// i18n yapılandırması
i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      tr: { translation: trTranslations },
      en: { translation: enTranslations }
    },
    fallbackLng: 'tr',
    supportedLngs: ['tr', 'en'],
    interpolation: {
      escapeValue: false // React zaten XSS koruması sağlar
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;